import { XCircle } from 'lucide-react'

export default function InvoiceCancelled() {
    return (
            <div className="w-full bg-white rounded-lg shadow-sm p-8 text-center">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                    <XCircle className="h-8 w-8 text-red-600" />
                </div>
                <h1 className="text-2xl font-semibold text-gray-900 mb-2">Invoice Cancelled</h1>
                <p className="text-gray-600 mb-6">
                    This invoice has been cancelled and is no longer valid.
                </p>
            </div>
    )
} 